import { Translation } from 'src/types';

export const translate = (translations: Translation[], locale: string) =>
    translations.find((translation) => translation.language === locale);
